import React from "react";
import { motion } from "framer-motion";

const LoadingSpinner = () => {
  const brandColor = "#F2791E";

  const spinTransition = {
    repeat: Infinity,
    duration: 1.2,
    ease: "linear",
  };

  return (
    <div className="t-fixed t-inset-0 t-z-[9999] t-flex t-items-center t-justify-center t-bg-white/80 t-backdrop-blur-md">
      <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-6">
        <div className="t-relative t-w-24 t-h-24">
          <motion.div
            animate={{ rotate: 360 }}
            transition={spinTransition}
            className="t-absolute t-inset-0 t-rounded-full t-border-4 t-border-transparent"
            style={{
              borderTopColor: brandColor,
              borderRightColor: brandColor,
            }}
          />

          <motion.div
            animate={{ rotate: -360 }}
            transition={{ ...spinTransition, duration: 2 }}
            className="t-absolute t-inset-2 t-rounded-full t-border-4 t-border-transparent"
            style={{
              borderBottomColor: brandColor,
              borderLeftColor: brandColor,
              opacity: 0.6,
            }}
          />

          <motion.div
            animate={{ scale: [0.8, 1.1, 0.8], opacity: [0.5, 1, 0.5] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            className="t-absolute t-inset-8 t-rounded-full"
            style={{ backgroundColor: brandColor }}
          />
        </div>

        <div className="t-flex t-gap-2">
          {[0, 0.2, 0.4].map((delay) => (
            <motion.div
              key={delay}
              animate={{ y: [0, -8, 0], opacity: [0.4, 1, 0.4] }}
              transition={{
                repeat: Infinity,
                duration: 0.8,
                delay: delay,
                ease: "easeInOut",
              }}
              className="t-w-3 t-h-3 t-rounded-full"
              style={{ backgroundColor: brandColor }}
            />
          ))}
        </div>

        <motion.p
          animate={{ opacity: [0.6, 1, 0.6] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="t-text-lg t-font-bold t-tracking-widest"
          style={{ color: brandColor }}
        >
          LOADING
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
